/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import './Footer.css';

// eslint-disable-next-line func-names
const Footer = () => {
  return (
    <div className="App-footer">
      <div className="footer-container">
        <div className="footer-data">
          <p className="copyright">©</p>
          <p className="year">2021</p>
          <a
            className="github-username"
            href="https://github.com/vikysan77"
            target="_blank"
            rel="noreferrer"
          >
            Vikysan77
          </a>
        </div>
        <a
          className="rss-logo"
          href="https://rs.school/index.html"
          target="_blank"
          rel="noreferrer"
          style={{
            backgroundImage: `url(./assets/svg/rss.svg)`,
          }}
        />
      </div>
    </div>
  );
};

export default Footer;
